import axios from '@/api/axios';

/**
 * Retrieves menu for specified restaurant
 * @param restaurantId
 * @returns {Promise<AxiosResponse<any>>}
 */
function menu({ restaurantId }) {
  return axios.get('/menu/', {
    params: {
      restaurant_id: restaurantId,
    },
  });
}

/**
 * Retrieves lazy menu
 * @param restaurantId
 * @returns {Promise<AxiosResponse<any>>}
 */
function readyBurgers({ restaurantId }) {
  return axios.get(`/menu/ready-burgers/${restaurantId}/`);
}

export default {
  menu,
  readyBurgers,
};



// WEBPACK FOOTER //
// ./src/apps/menu/api/index.js